export default {
  data () {
    return {
      curIndex: 0,
      totalSliders: []
    }
  },
  props: {
    sliderNum: {
      type: Number,
      default: 3
    },
    width: {
      type: Number,
      default: 44
    },
    height: {
      type: Number,
      default: 5
    },
    step: {
      type: Number,
      default: 0.15
    },
    isStop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sliderContainerStyle () {
      return {
        'width': this.width + 'px',
        'height': this.height + 'px'
      }
    }
  },
  mounted () {
    Object.keys(Array.apply(null, { length: this.sliderNum })).forEach((value) => {
      this.totalSliders.push({
        width: 0
      })
    })
    this.autoSlide()
  },
  methods: {
    autoSlide () {
      if (this.isStop) {
        setTimeout(this.autoSlide, 10)
        return
      }
      let curObj = this.totalSliders[this.curIndex]

      curObj.width += this.step
      if (curObj.width >= this.width) {
        this.curIndex++
        this.curIndex = this.curIndex >= this.sliderNum ? 0 : this.curIndex
        setTimeout(() => {
          curObj.width = 0
          this.$emit('changeImg', this.curIndex)
          this.autoSlide()
        }, 600)
      } else {
        setTimeout(this.autoSlide, 10)
      }
    },
    selectSomeone (value, index) {
      if (index === this.curIndex) return
      this.totalSliders.forEach(item => {
        item.width = 0
      })
      this.curIndex = index
      this.$emit('changeImg', this.curIndex)
    }
  }
}
